import React from "react";
import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import { SimpleSelect, CLIENT_TYPE_OPTIONS } from "./clientFormHelpers";

const BasicInfoStep = ({ formData, handleChange, accountNumber }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Account Number"
          name="accountNumber"
          value={formData.accountNumber}
          onChange={handleChange}
          InputProps={{ readOnly: accountNumber !== undefined }}
          fullWidth
          size="small"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Client Code" name="clientCode" value={formData.clientCode} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="PWS Number" name="pwsNumber" value={formData.pwsNumber} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Client Name" name="clientName" value={formData.clientName} onChange={handleChange} fullWidth size="small" required />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Status" name="status" value={formData.status} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Customer Type" name="customerType" value={formData.customerType} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SimpleSelect label="Client Type" name="clientType" value={formData.clientType} onChange={handleChange} options={CLIENT_TYPE_OPTIONS} />
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.syncWithKeap || false}
              onChange={handleChange}
              name="syncWithKeap"
              color="primary"
            />
          }
          label="Sync with Keap"
        />
      </Grid>
      {formData.dateCreated && (
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Date Added"
            value={formData.dateCreated ? new Date(formData.dateCreated).toLocaleDateString("en-US") : ""}
            InputProps={{ readOnly: true }}
            fullWidth
            size="small"
          />
        </Grid>
      )}
      {/* <Grid item xs={12} sm={6} md={3}>
        <TextField label="Remote Password" name="remotePassword" value={formData.remotePassword} onChange={handleChange} fullWidth size="small" />
      </Grid> */}
    </Grid>
  );
};

export default BasicInfoStep;
